"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ToggleContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useActiveElement = _interopRequireDefault(require("../utils/useActiveElement"));

var _useKeyDown = _interopRequireDefault(require("../utils/useKeyDown"));

var _excluded = ["children", "classes", "dataTestId", "id"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ToggleContext = /*#__PURE__*/(0, _react.createContext)();
exports.ToggleContext = ToggleContext;
var DropdownMenu = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      classes = _ref.classes,
      dataTestId = _ref.dataTestId,
      id = _ref.id,
      additionalProps = _objectWithoutProperties(_ref, _excluded);

  var menuRef = (0, _react.useRef)(ref);
  var focusedElement = (0, _useActiveElement.default)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      toggleShow = _useState2[0],
      setToggleShow = _useState2[1];

  var closeMenuOnClickedOutside = function closeMenuOnClickedOutside(event) {
    if (toggleShow && menuRef.current && !menuRef.current.contains(event.target)) {
      setToggleShow(false);
    }
  }; // close dropdown on click outside


  (0, _react.useEffect)(function () {
    document.addEventListener('mousedown', closeMenuOnClickedOutside);
    return function () {
      document.removeEventListener('mousedown', closeMenuOnClickedOutside);
    };
  }, [toggleShow]); // close dropdown on ESC press

  (0, _useKeyDown.default)('Escape', function () {
    return setToggleShow(false);
  }); // close dropdown if no element within has focus

  (0, _react.useEffect)(function () {
    var _menuRef$current;

    if (!(menuRef !== null && menuRef !== void 0 && (_menuRef$current = menuRef.current) !== null && _menuRef$current !== void 0 && _menuRef$current.contains(focusedElement))) {
      setToggleShow(false);
    }
  }, [focusedElement]);
  return /*#__PURE__*/_react.default.createElement(ToggleContext.Provider, {
    value: {
      toggleShow: toggleShow,
      setToggleShow: setToggleShow
    }
  }, /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)('dropdown-menu', classes),
    id: id,
    "data-testid": dataTestId,
    ref: menuRef
  }, additionalProps), children));
});
DropdownMenu.displayName = 'DropdownMenu';
DropdownMenu.propTypes = {
  /**
   Required. The contents of the dropdown menu. TriggerButton and MenuList are required.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,

  /**
   Optional. String to add custom class(es) to the component. Defaults to `null`.
   */
  classes: _propTypes.default.string,

  /**
   Optional. A unique identifier passed to the element for use in testing scenarios. Defaults to `null`.
   */
  dataTestId: _propTypes.default.string,

  /**
   Optional. A unique identifier passed to the element's `id` attribute. Defaults to `null`.
   */
  id: _propTypes.default.string
};
DropdownMenu.defaultProps = {
  classes: null,
  dataTestId: null,
  id: null
};
var _default = DropdownMenu;
exports.default = _default;